export const msalConfig = {
  auth: {
    clientId: "1aabd350-0bb8-41d2-b07d-51e5c8f17cb7",
    authority: "https://login.microsoftonline.com/3486c605-47d5-406f-8894-4e21c75dd48f",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "User.Read.All", "Files.Read.All", "Files.ReadWrite.All", "Sites.Read.All", "Sites.ReadWrite.All", "Mail.Send"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  sharepointSite: "triplecc.sharepoint.com",
  siteName: "MainSite",
  fileName: "Data Source_Master Tracker.xlsx",
};
